// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index." + {"440":"1b0bb3c949a29a4d61e0","581":"b7c1eabc00a5cb42e070"}[chunkId] + ".js";
};